import { USER_LANGUAGES } from '../assets/AppConstants';

export const getDefaultLanguage = () => {
  const browserLang = navigator.language.substring(0, 2);
  const language = USER_LANGUAGES.find((el) => (
    el.name.toLocaleLowerCase() === browserLang.toLocaleLowerCase()
  ));

  return language || USER_LANGUAGES[0];
};

/**
 * Same-tab anchor click to download a URL (e.g. an S3 presigned link). Unlike window.open it stays in the tab and
 * works cross-origin; relies on the response's Content-Disposition: attachment header.
 */
export const downloadFromUrl = (url) => {
  if (!url) return;
  const link = document.createElement('a');
  link.href = url;
  link.rel = 'noopener';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
};
